import { render, staticRenderFns } from "./DailyChallengeReminder.vue?vue&type=template&id=6efb83fa&scoped=true&"
import script from "./DailyChallengeReminder.vue?vue&type=script&lang=ts&"
export * from "./DailyChallengeReminder.vue?vue&type=script&lang=ts&"
import style0 from "./DailyChallengeReminder.vue?vue&type=style&index=0&id=6efb83fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efb83fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6efb83fa', component.options)
    } else {
      api.reload('6efb83fa', component.options)
    }
    module.hot.accept("./DailyChallengeReminder.vue?vue&type=template&id=6efb83fa&scoped=true&", function () {
      api.rerender('6efb83fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/dailyproblems/components/DailyChallengeReminder.vue"
export default component.exports